export function validateOptional(validator, options = { allowNull: false, allowUndefined: true }) {
    return (value, logger, logLabel) => {
        if (options.allowUndefined && value === undefined)
            return true;
        if (options.allowNull && value === null)
            return true;
        return validator(value, logger, logLabel);
    };
}
//# sourceMappingURL=optional.js.map